export default "__VITE_ASSET__DqGMk33e__";